import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative h-[600px] overflow-hidden">
      <motion.div 
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 10, ease: "easeOut" }}
        className="absolute inset-0"
      >
        <img
          src="/images/home2.jpeg"
          alt="Villa di lusso"
          className="w-full h-full object-cover"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-primary/80"></div>
      </motion.div>
      
      <div className="relative max-w-7xl mx-auto px-4 h-full">
        <div className="flex flex-col h-full justify-center">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl text-white"
          >
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: "100px" }}
              transition={{ delay: 0.2, duration: 0.8 }}
              className="h-1 bg-secondary mb-8"
            ></motion.div>
            <motion.span 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-secondary-light font-semibold mb-2 block text-lg"
            >
              Dal 2017 realizziamo sogni
            </motion.span>
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="text-5xl sm:text-6xl md:text-7xl font-monomakh mb-8 leading-tight"
            >
              La Casa che<br/> Hai Sempre Sognato
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
              className="text-xl sm:text-2xl font-light max-w-2xl"
            >
              Non vendiamo case, ma realizziamo emozioni. Ogni mattone racconta una storia, 
              ogni spazio custodisce ricordi. Trova il luogo perfetto per scrivere il tuo futuro.
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;